import Vue from 'vue';
import i18n from '../plugins/i18n';

const tipoAttributo = (value?: string) => {
    if (!value) {
        return '';
    }
    return i18n.t('labels.tipo-attributo-' + value);
}

Vue.filter('tipoAttributo', (value?: string) => {
    return tipoAttributo(value);
});